export const mobile = [
    {name:"React Native", description: "A cross platform mobile development framework", image:"/images/react-native.png"},
]

export const frontend = [
    {name:"Javascript", description: "Awesome Client Side Scripting Language", image:"/images/javascript.png"},
    {name:"Bootstrap", description: "Amazing CSS framework for rapid Web development", image:"/images/bootstrap.png"},
    {name:"TailwindCSS", description: "Awesome Utility based CSS framework for rapid Web development", image:"/images/tailwind.png"},
    {name:"Materialize", description: "Google's Material Design based CSS framework", image:"/images/materialize.jpeg"},
    {name:"React", description: "Awesome Javascript frontend framework", image:"/images/react.png"},
    {name:"NextJS", description: "Awesome Javascript React based fullstack framework", image:"/images/next.jpeg"},
    {name:"MaterialUI", description: "Awesome Material Design based CSS framework for React", image:"/images/materialui.jfif"},
    {name:"Vue", description: "Awesome Javscript frontend framework", image:"/images/vue.jpg"},
    {name:"Vuetify", description: "Awesome Material Design based CSS framework for Vue", image:"/images/vuetify.png"},
    {name:"SASS", description: "Awesome CSS preprocessor", image:"/images/sass.png"},
    {name:"GSAP", description: "Greensock Animation Library", image:"/images/gsap.png"},
    {name:"Framer Motion", description: "React animation Library", image:"/images/framer-motion.png"},
    {name:"Redux", description: "State Management Library", image:"/images/redux.jpg"},
]
export const backend = [
    {name:"Node Js", description: "Awesome Javascript framework", image:"/images/node.png"},
    {name:"C#", description: "Dotnet Core", image:"/images/csharp.png"},
    {name:"PHP", description: "Backend Scripting Language", image:"/images/php.png"},
    {name:"Laravel", description: "Awesome PHP framework", image:"/images/laravel.png"},
    {name:"MysQL", description: " Awesome Relational Database", image:"/images/mysql.jpg"},
    {name:"MongoDB", description: "Awesome Non-relational Database", image:"/images/mongodb.jfif"},
    {name:"PostMan", description: "Awesome Api Testing tool", image:"/images/postman.png"},
    {name:"MSSQL", description: "Microsoft Structured Query Language", image:"/images/mssql.png"},
]

export const design = [
    {name:"Adobe XD", description: "Adobe XD", image:"/images/adobe.png"},
    {name:"Figma", description: "Figma ", image:"/images/figma.png"},
    {name:"PhotoShop", description: "Adobe Photoshop", image:"/images/photoshop.png"},

]
